import React from 'react'

const SvgWinkFaceFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-9.932 3.984c.923-.034 1.789-.448 2.28-1.052a1 1 0 011.552 1.262c-.903 1.11-2.34 1.736-3.757 1.79-1.438.052-2.97-.484-3.973-1.85a1 1 0 011.613-1.183c.54.736 1.383 1.067 2.285 1.033zm-2.201-4.296a1 1 0 11-2 0 1 1 0 012 0zm-1.22-3.033c-.394.118-.698.338-.826.51a.75.75 0 11-1.2-.901c.364-.484.97-.86 1.6-1.047.635-.188 1.424-.221 2.127.16a.75.75 0 11-.718 1.318c-.245-.133-.594-.155-.982-.04zm7.018 3.974c-.064-.078-.266-.224-.571-.3-.294-.074-.559-.05-.742.044a.75.75 0 11-.688-1.333c.598-.309 1.26-.3 1.794-.166.522.13 1.05.412 1.373.812a.75.75 0 01-1.166.943zm.156-2.967c.395.117.698.338.826.509a.75.75 0 101.2-.9c-.363-.484-.97-.86-1.6-1.047-.635-.189-1.424-.222-2.126.16a.75.75 0 10.717 1.318c.245-.133.595-.155.983-.04z'
    />
  </svg>
)

export default SvgWinkFaceFilled
